import "./OwnLayout.scss"
import Header from "./Header";
import { FloatButton, Layout } from "antd";
import { Outlet } from "react-router-dom";
import FooterApp from "./FooterApp";
const { Header: AntHeader, Content, Footer } = Layout;
const OwnLayout = ({t}) => {
  return (
    <div className="min-layout">
        <Layout className="site-layout"
          style={{
            minHeight: '100vh',
          }}
        >
          <AntHeader
            style={{
              height: '64px',
              // padding: '0px',
              // position: 'sticky',
              // top: 0,
              // zIndex: 1000,
              padding: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: 'transparent',
            }}
          >
            <Header t={t} />
          </AntHeader>
          <Content
            // style={{
              // padding: '0 50px',
            // }}
          >
            <Outlet />
            <FloatButton.BackTop  className="back-top" />
          </Content>
          <Footer
            // style={{
            //   padding: '0px 30px',
            // }}
          >
            <FooterApp t={t} />
          </Footer>
      </Layout>
    </div>
  );
}

export default OwnLayout